import script from "./FAQAccordian_prp_home.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQAccordian_prp_home.vue?vue&type=script&setup=true&lang=js"

import "./FAQAccordian_prp_home.vue?vue&type=style&index=0&id=ff33eec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff33eec2"]])

export default __exports__